var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showModal && _vm.loadedItem
    ? _c("div", { staticClass: "quick-view__wrapper" }, [
        _c("div", {
          staticClass: "quick-view__backdrop",
          class: { "modal-visible": _vm.displayModal }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "quick-view__modal",
            class: { "modal-visible": _vm.displayModal },
            attrs: { tabindex: "-1", role: "dialog" }
          },
          [
            _c("div", { staticClass: "modal-dialog" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    {
                      staticClass: "quick-view__close",
                      on: {
                        click: function($event) {
                          return _vm.closeQuickView()
                        }
                      }
                    },
                    [
                      _c("svg", { attrs: { width: "18", height: "18" } }, [
                        _c("use", {
                          attrs: {
                            "xlink:href": "#svg_close",
                            "xmlns:xlink": "http://www.w3.org/1999/xlink"
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-7 left-side" },
                      [
                        _vm.displayModal
                          ? _c("item-image-carousel", {
                              attrs: {
                                "item-data": _vm.currentVariation,
                                "plugin-path": _vm.pluginPathCeres,
                                "image-url-accessor": "url"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "widget widget-code widget-none mt-5"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "widget-inner bg-appearance" },
                              [
                                _c("div", [
                                  _c("div", {
                                    staticClass: "single__features",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.currentVariation.texts
                                          .shortDescription
                                      )
                                    }
                                  })
                                ])
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-5" }, [
                      _c(
                        "div",
                        { staticClass: "quick-view__right-side" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "widget widget-text widget-none title-outer m-0"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "widget-inner bg-appearance pt-0 pr-0 pb-0 pl-0"
                                },
                                [
                                  _c("h1", { staticClass: "single__name" }, [
                                    _c("span", [_vm._v(_vm._s(_vm.itemName))])
                                  ])
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "widget widget-item-price widget-none single__prices"
                            },
                            [
                              _c("item-price", {
                                attrs: {
                                  "item-data": _vm.currentVariation,
                                  "show-cross-price":
                                    _vm.isRecommendedPriceActive
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "widget widget-code widget-none m-0"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "widget-inner bg-appearance pt-0 pr-0 pb-0 pl-0 mt-0 mr-0 mb-0 ml-0"
                                },
                                [_c("vat-component")],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isConfActive
                            ? [
                                _c("wall-configurator", {
                                  attrs: {
                                    "confi-article-list": _vm.confArticleList,
                                    "swiper-color-list": _vm.confColorIds,
                                    "conf-matrix": _vm.confMatrix,
                                    "item-data": _vm.currentVariation,
                                    "is-quick-view": true
                                  }
                                })
                              ]
                            : [
                                this.crossseller !== null &&
                                _vm.crossseller.length > 0
                                  ? _c("variation-cross-selling", {
                                      attrs: {
                                        "item-data": _vm.currentVariation,
                                        "is-quick": true,
                                        crossSellingItems: _vm.crossseller
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("variation-select", {
                                  attrs: { "item-data": _vm.currentVariation }
                                })
                              ],
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "widget widget-grid widget-two-col row single__wishlist"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "widget-inner col-xl-9 widget-prop-xl-2-1 col-lg-9 widget-prop-lg-2-1 col-md-9 widget-prop-md-2-1 col-sm-12 widget-prop-sm-3-1 widget-stacked-mobile col-12 widget-prop-3-1 widget-stacked-mobile"
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "widget widget-add-to-basket widget-primary mt-3 mb-3"
                                      },
                                      [
                                        _c("add-to-basket", {
                                          attrs: {
                                            "variation-id":
                                              _vm.currentVariation.variation.id,
                                            "is-salable":
                                              !!_vm.currentVariation.filter &&
                                              _vm.currentVariation.filter
                                                .isSalable,
                                            "has-children":
                                              !!_vm.currentVariation.filter &&
                                              _vm.currentVariation.filter
                                                .hasActiveChildren,
                                            "interval-quantity":
                                              _vm.currentVariation.variation
                                                .intervalOrderQuantity || 1,
                                            "minimum-quantity":
                                              _vm.currentVariation.variation
                                                .minimumOrderQuantity,
                                            "maximum-quantity":
                                              !!_vm.currentVariation.variation
                                                .maximumOrderQuantity &&
                                              _vm.currentVariation.variation
                                                .maximumOrderQuantity > 0
                                                ? _vm.currentVariation.variation
                                                    .maximumOrderQuantity
                                                : null,
                                            "order-properties": _vm.currentVariation.properties.filter(
                                              function(prop) {
                                                return prop.property
                                                  .isOderProperty
                                              }
                                            ),
                                            "use-large-scale": false,
                                            "show-quantity": true,
                                            origin: "category",
                                            "item-data": _vm.currentVariation,
                                            "item-url": _vm._f("itemURL")(
                                              _vm.currentVariation
                                            ),
                                            "is-variation-selected":
                                              _vm.isVariationSelected &&
                                              _vm.currentVariation.filter
                                                .isSalable,
                                            "has-price": _vm._f(
                                              "hasItemDefaultPrice"
                                            )(_vm.currentVariation)
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "widget-inner col-xl-3 widget-prop-xl-auto col-lg-3 widget-prop-lg-auto col-md-3 widget-prop-md-auto col-sm-12 widget-prop-sm-3-1 col-12 widget-prop-3-1"
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "widget widget-add-to-wish-list widget-none single__wishlist-btn"
                                      },
                                      [
                                        _c("add-to-wish-list", {
                                          attrs: {
                                            "variation-id":
                                              _vm.currentVariation.variation.id
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "btn w-100 quick-view__goto-item",
                              attrs: {
                                href: _vm._f("itemURL")(_vm.currentVariation)
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Weberbuero::Template.quickViewDetails"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("availability"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "widget widget-grid widget-two-col row single__wishlist"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "widget-inner col-xl-12 widget-prop-xl-auto col-lg-12 widget-prop-lg-auto col-md-12 widget-prop-md-3-1 col-sm-12 widget-prop-sm-3-1 widget-stacked-mobile col-12 widget-prop-3-1 widget-stacked-mobile"
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "widget widget-text widget-none single__article-number m-0"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "widget-inner bg-appearance pt-0 pr-0 pb-0 pl-0 mt-0 mr-0 mb-0 ml-0"
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Weberbuero::Template.singleItemId"
                                                  )
                                                ) + ": "
                                              ),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentVariation.item.id
                                                  )
                                                )
                                              ])
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(0)
                        ],
                        2
                      )
                    ])
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "widget widget-code widget-none mb-0" }, [
      _c("div", { staticClass: "widget-inner bg-appearance" }, [
        _c(
          "div",
          { staticClass: "text-center widget widget-d2g widget-payment-icons" },
          [
            _c("div", { staticClass: "widget-inner" }, [
              _c(
                "ul",
                {
                  staticClass:
                    "list-unstyled d-flex flex-wrap justify-content-start icon-size-s"
                },
                [
                  _c("li", { staticClass: "amazon-pay" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://bilder.weberbuero.de/frontend/images/shop/amazon-pay.svg",
                        alt: "Amazon Pay - Zahlen Sie mit Ihrem Amazon-Account",
                        title:
                          "Amazon Pay - Zahlen Sie mit Ihrem Amazon-Account"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "paypal" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://bilder.weberbuero.de/frontend/images/shop/paypal.svg",
                        alt: "PayPal",
                        title: "PayPal"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "visa" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://bilder.weberbuero.de/frontend/images/shop/visa.svg",
                        alt: "VISA",
                        title: "VISA"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "mastercard" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://bilder.weberbuero.de/frontend/images/shop/mastercard.svg",
                        alt: "Mastercard",
                        title: "Mastercard"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "invoice" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://bilder.weberbuero.de/frontend/images/shop/Rechnungskauf_1.svg",
                        alt: "Rechnungskauf nach Freischaltung",
                        title: "Rechnung nach Freischaltung"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "american-express" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://bilder.weberbuero.de/frontend/images/shop/american-express.svg",
                        alt: "American Express",
                        title: "American Express"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "sepa-directdebit" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "https://bilder.weberbuero.de/frontend/images/shop/sepa.svg",
                        alt: "SEPA Lastschrift",
                        title: "SEPA Lastschrift"
                      }
                    })
                  ])
                ]
              )
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }